// extracted by mini-css-extract-plugin
module.exports = {"alert":"Jfp234Cj"};